import React from "react"
import PropTypes from "prop-types"

import PlatformSpecificActionButton from "app/static/frontend/search-new/containers/FilterableListView/ActionButtonContainer"
import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"

export default function ActionButton(props) {
    const action = () => {
        if (props.uniqueActionButtonId && props.hasDisplayComponent) {
            props.setActiveActionButton(props.uniqueFlvId, props.uniqueActionButtonId)
        }

        if (props.uniqueActionButtonId === "displayVisualizationsButton" && !props.isActive) {
            // If 'Show Visualizations' button is clicked, send useraction
            sendUserActionPost({
                userActionType: DjangIO.app.useractions.types.UserActionType.visualization_opened,
                quorumDataType: props.quorumDataType
            })
        }

        if (props.callback) {
            return props.callback()
        }

        return undefined
    }

    return (
        <PlatformSpecificActionButton
            uniqueFlvId={props.uniqueFlvId}
            action={action}
            key={props.uniqueActionButtonId}
            {...props}
        />
    )
}

ActionButton.propTypes = {
    uniqueFlvId: PropTypes.string.isRequired,
    uniqueActionButtonId: PropTypes.string,
    hasDisplayComponent: PropTypes.bool,
    isActive: PropTypes.bool,
    setActiveActionButton: PropTypes.func.isRequired,
    callback: PropTypes.func,
    quorumDataType: PropTypes.number,
}
